import {
	Badge,
	Box,
	Center,
	Flex,
	Icon,
	Image,
	SimpleGrid,
	Text,
} from '@chakra-ui/react';
import CopyableChip from 'components/table/copyableChip';

export default function ListingCard({
	idx,
	cardBg,
	iconBg,
	borderColor = 'gray.300',
	imageSrc,
	iconComponent,
	title,
	subtitle,
	badge,
	details = [],
	extraContent = null,
}) {
	return (
		<Box
			key={idx}
			p={5}
			borderRadius='xl'
			bg={cardBg}
			boxShadow='md'
			borderLeft='6px solid'
			borderColor={borderColor}
		>
			<SimpleGrid columns={{ base: 1, md: 2 }} spacing={3}>
				<Flex align='center' gap={6}>
					{imageSrc ? (
						<Box boxSize='50px' borderRadius='50%' overflow='hidden'>
							<Image
								src={imageSrc}
								alt={title}
								boxSize='100%'
								objectFit='cover'
								transform='scale(1.02)'
							/>
						</Box>
					) : (
						<Center boxSize='50px' bg={iconBg} borderRadius='full'>
							<Icon as={iconComponent} boxSize={5} color='gray.100' />
						</Center>
					)}
					<Box>
						{title && <Text fontWeight='bold'>{title}</Text>}
						{subtitle && <Text fontSize='sm'>{subtitle}</Text>}
					</Box>
				</Flex>

				<Flex
					direction={'column'}
					alignItems={{ base: 'flex-start', md: 'flex-end' }}
					mt={{ base: '24px', md: '0px' }}
					textAlign={{ base: 'left', md: 'right' }}
				>
					{details.map(({ label, value, type }, i) => {
						if (!value) return null;

						if (type === 'copyable_chip') {
							return <CopyableChip key={i} value={value} copyable={true} />;
						}

						return (
							value && (
								<Text key={i} mt={i > 0 ? 2 : 0} fontSize='sm'>
									{label}: <strong>{value}</strong>
								</Text>
							)
						);
					})}
					{badge && (
						<Badge mt={4} colorScheme={badge.colorScheme} width={'fit-content'}>
							{badge.label}
						</Badge>
					)}
					{extraContent}
				</Flex>
			</SimpleGrid>
		</Box>
	);
}
